import css from 'styled-jsx/css'

import { colors } from '../../theme'


export default css`
  :global(.highlighted) {
    position: relative;
  }

  :global(.highlighted .light) {
    z-index: -1;
    position: absolute;
    bottom: 10%;
    left: -0.1%;
    right: -0.1%;
    height: 20%;
    background-color: ${colors.yellow};
  }
`
